var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.SessionBlock,{attrs:{"narrow":"","id":"login-view"}},[_c(_setup.UserLogin,{ref:"userLogin",attrs:{"id":"user-login"},on:{"login-success":_setup.onLoginSuccess,"stage-change":function($event){_setup.currentStage = $event}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }